import dayjs from 'dayjs';
import { CLOCK_TIME_FORMAT } from './formatClockTime';

const DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/;
const DATE_FORMAT = 'YYYY-MM-DD';
export const DATE_TIME_FORMAT = `${DATE_FORMAT} ${CLOCK_TIME_FORMAT}`;

/**
 * The calendar date of a value that is either a plain date or a timestamp. A timestamp is
 * read in local time, so Swedish midnight stored as `2026-03-17T23:00:00.000Z` is the 18th.
 */
export const toDateOnly = (value: string | null | undefined): string => {
  if (!value) return '';
  if (DATE_ONLY.test(value)) return value;

  const date = dayjs(value);
  return date.isValid() ? date.format(DATE_FORMAT) : '';
};

export const today = (): string => dayjs().format(DATE_FORMAT);

/** Whether a date is over: false on the date itself, true from local midnight after it. */
export const isBeforeToday = (value: string | null | undefined): boolean => {
  const date = toDateOnly(value);
  return !!date && date < today();
};

export const monthRange = (date: string): { start: string; end: string } => {
  const day = dayjs(toDateOnly(date));
  return {
    start: day.startOf('month').format(DATE_FORMAT),
    end: day.endOf('month').format(DATE_FORMAT),
  };
};
